export const PACKAGE_INCLUSIONS_GRID_COLUMNS = '48px minmax(180px, 0.8fr) minmax(280px, 1.2fr) 130px 150px 150px 48px';
